var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fetching)?_c('loading-spinner',{attrs:{"full-page":""}}):_c('router-view',_vm._b({},'router-view',_vm.profileData,false))
}
var staticRenderFns = []

export { render, staticRenderFns }